import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import PartnerSetupPage from "@/pages/partner/PartnerSetupPage";
export const Route = createFileRoute("/partner_/setup")({
  head: () =>
    pageHead(
      "Partner Setup",
      "Secure Partner account access.",
      "/partner/setup",
      true,
    ),
  component: PartnerSetupPage,
});
